// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 468 ? "pricelists-pdf" : chunkId) + "." + {"468":"434b74e43aa3bd6fadc8","884":"025c79731ba610d75231"}[chunkId] + ".js";
};